interface FileInputProps {
    file?: File;
    onChange(e: React.ChangeEvent<HTMLInputElement>): void;
    resetFile(): void;
}

const Fileinput = ({ file, onChange, resetFile }: FileInputProps) => (
    <div className='display-flex justify-content-start text-white'>
        <div className='max-w-240px'>
            {!file ? (
                <input
                    className='max-w-200px cursor-pointer'
                    type='file'
                    onChange={onChange}
                    accept='application/JSON'
                    data-testid='upload-simulation-scenario-file-input'
                />
            ) : (
                <p className=''>
                    {file.name}
                    <span
                        data-testid='file-input-remove'
                        onClick={resetFile}
                        className='rioglyph rioglyph-remove mx-5 cursor-pointer text-16 text-danger'
                    />
                </p>
            )}
        </div>
    </div>
);

export default Fileinput;
